import { Outlet } from 'react-router-dom';

const OutletRole = () => {
  return <Outlet />;
};

export default OutletRole;
